import _ from "lodash"
import { createReducer } from '../../../common/reduxHelpers';
import { actionTypes as profileActions } from '../profile';
import { actionTypes as contactsActions } from '../profile/contacts';

const setIsProfileLoading = value => (state, action) => _.assign({}, state, { isFetchingProfile: value });
const setIsContactDetailsVisible = value => (state, action) => _.assign({}, state, { isContactDetailsVisible: value });
const setIsOTTStatusLoading = value => (state, action) => _.assign({}, state, { isOTTStatusLoading: value });

const reducer = createReducer({}, {
    [profileActions.FETCH_PROFILE_REQUEST]: setIsProfileLoading(true),
    [profileActions.FETCH_PROFILE_SUCCESS]: setIsProfileLoading(false),
    [profileActions.FETCH_PROFILE_FAILURE]: setIsProfileLoading(false),
    [contactsActions.CONTACT_SELECTED]: setIsContactDetailsVisible(true),
    [contactsActions.CONTACT_CLOSED]: setIsContactDetailsVisible(false),
});

export default reducer;


